import React from "react";
import Dialog from "components/Overlays/ResponsiveDialog";
import GeoRestrictionManager from "components/GeoRestrictionManager";

const GeoRestrictionModal = ({ visible, onHide, bookId, bookTitle }) => {
	return (
		<Dialog
			visible={visible}
			onHide={onHide}
			header="Manage Geo-Restrictions"
			modal
			className="p-fluid"
			style={{ width: "800px", maxWidth: "90vw" }}
			breakpoints={{ "960px": "80vw", "641px": "95vw" }}
			draggable={false}
			resizable={false}
		>
			<GeoRestrictionManager bookId={bookId} bookTitle={bookTitle} onClose={onHide} />
		</Dialog>
	);
};

export default GeoRestrictionModal;
